import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { selectHasSummarizationSettingsPermission } from '../../../../../../pages/call/features/permissions';
import {
    selectIsSummarizationAvailable,
    selectIsSummarizationMailForParticipants,
    setIsSummarizationMailForParticipantsAction,
} from '../../../../../../pages/call/features/summarization';
import { i18n } from '../../../../../helpers/i18n';
import { selectIsCalendarSummarizationFeatureEnabled } from '../../../../flags/selectors';
import { useOnPermissionChange } from '../../../hooks/use-on-permission-change';
import { SettingsTumbler } from './settings-tumbler';

export const SummarizationMailRecipientTumbler: FunctionComponent = () => {
    const isSummarizationAvailable = useSelector(selectIsSummarizationAvailable);
    const isSummarizationMailForParticipants = useSelector(selectIsSummarizationMailForParticipants);
    const hasSummarizationSettingsPermission = useSelector(selectHasSummarizationSettingsPermission);
    const calendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);

    const onChange = useOnPermissionChange(
        setIsSummarizationMailForParticipantsAction,
        'summarization_mail_for_participants'
    );

    if (
        !isSummarizationAvailable ||
        !hasSummarizationSettingsPermission ||
        isSummarizationMailForParticipants === null
    ) {
        return null;
    }

    return (
        <SettingsTumbler
            testId="summarization-mail-recipient-tumbler"
            label={i18n(
                'settings-v2',
                calendarSummarizationFeatureEnabled ? 'receive-summary-on-mail-v2' : 'receive-summary-on-mail'
            )}
            checked={isSummarizationMailForParticipants}
            onChange={onChange}
        />
    );
};
